import React from 'react'

const Blocklist = () => {
  return (
    <div>Blocklist</div>
  )
}

export default Blocklist